import {Component, OnDestroy, OnInit} from "@angular/core";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {toastrService} from "src/app/services/ux/toastr.service";
import {UserHttpClientService} from "../../data/user-http-client.service";
import {finalize} from "rxjs/operators";
import {Subscription} from "rxjs/internal/Subscription";
import {User} from "../../models/User/user";
import { TranslateService } from "@ngx-translate/core";


@Component({
    templateUrl: "./ankesa.component.html",
    styleUrls: ["./ankesa.component.css"]
})
export class AnkesaComponent implements OnInit, OnDestroy {

    // region Subscriptions
    userDetails$ = new Subscription();
    complaint$ = new Subscription();
    // endregion

    complaintForm: FormGroup;
    isLoading = false;

    userDetails = {} as User;

    constructor(
      private fb: FormBuilder,
      public toastr: toastrService,
      private userHttpClient: UserHttpClientService,
      private translateService: TranslateService
    ) {
        this.complaintForm = fb.group({
            from_name: ["", [Validators.required]],
            from_surname: ["", Validators.required],
            from_email: ["", Validators.required],
            subject: ["undefined", Validators.required],
            message: ["", Validators.required]
        });
    }

    ngOnInit() {
        this.isLoading = true;

        this.userDetails$ = this.userHttpClient.getUserDetails()
            .pipe(
                finalize(
                    (): void => {
                        this.isLoading = false;
                    }
                )
            ).subscribe(
                {
                    next: (user) => {
                        this.userDetails = user;

                        this.complaintForm.patchValue(
                            {
                                from_name: user.first_name || user.administrator_first_name,
                                from_surname: user.last_name || user.administrator_last_name,
                                from_email: user.email
                            }
                        );
                    }
                }
            );
    }

    send() {
        if (!this.complaintForm.valid) {
            return this.toastr.warning(this.translateService.instant("AnkesaModule.PleaseFillInAllTheFields"));
        }
        this.isLoading = true;

        this.complaint$ = this.userHttpClient.sendComplaintOrImprovement({
            ...this.complaintForm.value,
            from_company_name: this.userDetails.company_name
        })
            .pipe(
                finalize(
                    (): void => {
                        this.isLoading = false;
                    }
                )
            )
            .subscribe(
                {
                    next: () => {
                        const text = this.complaintForm.value.subject 
                          ? this.translateService.instant("AnkesaModule.Complaint")
                          : this.translateService.instant("AnkesaModule.Request");
                        this.toastr.success(this.translateService.instant("AnkesaModule.SuccessText", { text }));
                        this.complaintForm.patchValue(
                            {
                                subject: "undefined",
                                message: ""
                            }
                        );
                    },
                    error: () => {
                        this.toastr.warning(this.translateService.instant("AnkesaModule.AnErrorOccur"));
                    }
                }
            );
    }

    ngOnDestroy() {
        this.userDetails$.unsubscribe();
        this.complaint$.unsubscribe();
    }

}
